import api from '../api';

export const LLMExtract = async (
  prompt: string,
  promptName: string,
  JWT: string | undefined,
  title?: string,
): Promise<Response> => {
  // console.log('[LLMExtract] Sending request to /morphseek/extract');
  const { data } = await api.post(
    `/morphseek/extract`,
    { prompt, promptName },
    {
      timeout: 60000,
      headers: { Authorization: `Bearer ${JWT}` },
    },
  );
  // console.log('[LLMExtract] Response received, text length:', data?.text?.length ?? 'no text field');
  return data;
};
